/**
 * Helper para construir URLs de fotos
 * 
 * Maneja tanto fotos locales como de Cloudinary:
 * - Si la foto es una URL de Cloudinary: la devuelve directamente
 * - Si la foto es una ruta local: construye la URL completa usando el API endpoint
 */

import { API_ENDPOINTS } from '../config';

/**
 * Verifica si una URL es de Cloudinary
 * @param {string} url - URL a verificar
 * @returns {boolean}
 */
export function esUrlCloudinary(url) {
  if (!url) return false;
  return url.includes('res.cloudinary.com') || url.includes('cloudinary.com');
}

/**
 * Construye la URL completa de una foto
 * @param {string} foto - Ruta de foto (local) o URL completa (Cloudinary)
 * @returns {string} - URL completa de la foto
 */
export function construirUrlFoto(foto) {
  if (!foto) return '';
  
  // Si ya es una URL completa (Cloudinary), devolverla directamente
  if (esUrlCloudinary(foto) || foto.startsWith('http://') || foto.startsWith('https://')) {
    return foto;
  }
  
  // Si es una ruta local, construir la URL completa
  const fotoUrl = foto.replace('/public', '');
  return API_ENDPOINTS.SOCIOS.replace('/socios', '') + fotoUrl;
}
